import {
    SECTIONS_LIST_REQUEST, SECTIONS_LIST_SUCCESS, SECTIONS_LIST_FAIL,
    SECTION_DETAIL_REQUEST, SECTION_DETAIL_SUCCESS, SECTION_DETAIL_FAIL,
    QUIZ_FETCH_REQUEST, QUIZ_FETCH_SUCCESS, QUIZ_FETCH_FAIL,
    QUIZ_SUBMIT_REQUEST, QUIZ_SUBMIT_SUCCESS, QUIZ_SUBMIT_FAIL, QUIZ_SUBMIT_RESET,
} from '../constants/courseConstants'

export const sectionsListReducer = (state = { sections: [] }, action) => {
    switch (action.type) {
        case SECTIONS_LIST_REQUEST: return { loading: true, sections: [] }
        case SECTIONS_LIST_SUCCESS: return { loading: false, sections: action.payload }
        case SECTIONS_LIST_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const sectionDetailReducer = (state = { section: null }, action) => {
    switch (action.type) {
        case SECTION_DETAIL_REQUEST: return { loading: true, section: null }
        case SECTION_DETAIL_SUCCESS: return { loading: false, section: action.payload }
        case SECTION_DETAIL_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const quizFetchReducer = (state = { quiz: null }, action) => {
    switch (action.type) {
        case QUIZ_FETCH_REQUEST: return { loading: true, quiz: null }
        case QUIZ_FETCH_SUCCESS: return { loading: false, quiz: action.payload }
        case QUIZ_FETCH_FAIL:    return { loading: false, error: action.payload }
        default: return state
    }
}

export const quizSubmitReducer = (state = {}, action) => {
    switch (action.type) {
        case QUIZ_SUBMIT_REQUEST: return { loading: true }
        case QUIZ_SUBMIT_SUCCESS: return { loading: false, result: action.payload }
        case QUIZ_SUBMIT_FAIL:    return { loading: false, error: action.payload }
        case QUIZ_SUBMIT_RESET:   return {}
        default: return state
    }
}
